import { faGrid, faList } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useSetState } from '@domain-group/react-hooks'

import { Box, DashboardModule, Link } from '@domain-group/suit-theme'

import useSavedArtworks from '@hooks/useSavedArtworks'

import GridView from '../Views/GridView'
import ListView from '../Views/ListView'

type DefaultState = {
  gridView: boolean,
}

const defaultState: DefaultState = {
  gridView: false,
}

// @ts-expect-error TS2304
const SavedArtworks = (props: PageContentProps) => {
  const { pageFilters, selectedAgencyId } = props
  const [state, setState] = useSetState(defaultState)
  const { gridView } = state

  const savedArtworksPayload = useSavedArtworks({
    filters: { agency_id: selectedAgencyId, ...pageFilters },
    performHttpRequests: true,
    requestOptions: {
      include_saved_artwork_first_page: true,
      include_saved_artwork_page_count: true,
      include_saved_artwork_page_preview: true,
      include_saved_artwork_user: true,
    },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredSavedArtworks,
    filteredSavedArtworksCount,
    hasFilteredSavedArtworks,
    loading,
  } = savedArtworksPayload

  const Component = gridView ? GridView : ListView

  return (
    <Box marginBottom="large">
      <DashboardModule
        boxProps={{ borderBottom: `${loading ? 'none' : ''}` }}
        contentBoxProps={{ flexDirection: 'column' }}
        headerRight={(
          <Link greyLink onClick={() => setState({ gridView: !gridView })}>
            <FontAwesomeIcon icon={gridView ? faList : faGrid} />
          </Link>
          )}
        loading={loading}
        title="Saved Artworks"
      >
        {!loading && hasFilteredSavedArtworks && (
          <Component entities={filteredSavedArtworks} />
        )}

        {!loading && !hasFilteredSavedArtworks && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Saved ArtworkPages present
            </DashboardModule.BlankState.Title>
          </DashboardModule.BlankState>
        )}

        <DashboardModule.LoadMoreFooter
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredSavedArtworksCount}
          loading={loading}
        />
      </DashboardModule>
    </Box>
  )
}

export default SavedArtworks
